import { render, staticRenderFns } from "./HostingKvmInfo.vue?vue&type=template&id=7a2168c2&scoped=true&"
import script from "./HostingKvmInfo.vue?vue&type=script&lang=js&"
export * from "./HostingKvmInfo.vue?vue&type=script&lang=js&"
import style0 from "./HostingKvmInfo.vue?vue&type=style&index=0&id=7a2168c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2168c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a2168c2')) {
      api.createRecord('7a2168c2', component.options)
    } else {
      api.reload('7a2168c2', component.options)
    }
    module.hot.accept("./HostingKvmInfo.vue?vue&type=template&id=7a2168c2&scoped=true&", function () {
      api.rerender('7a2168c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/HostingKvmInfo.vue"
export default component.exports